import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=bc9cca98&"
import script from "./Branch.vue?vue&type=script&lang=js&"
export * from "./Branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc9cca98')) {
      api.createRecord('bc9cca98', component.options)
    } else {
      api.reload('bc9cca98', component.options)
    }
    module.hot.accept("./Branch.vue?vue&type=template&id=bc9cca98&", function () {
      api.rerender('bc9cca98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Branch.vue"
export default component.exports